import * as React from 'react'

type PlusMinusToggleProps = {
  signMultiplier: number
  onSignChange: (newSignMultiplier: number) => void
  disabled?: boolean
}

export default function PlusMinusToggle(props: PlusMinusToggleProps) {
  const { signMultiplier, onSignChange, disabled = false } = props
  return (
    <div className="form-group mr-1">
      <div>
        <div className="btn-group btn-group-toggle">
          <label className={`btn ${signMultiplier >= 0 ? 'active resources-adjustment-up' : 'btn-outline-secondary '}`}>
            <input
              type="radio"
              disabled={disabled}
              checked={signMultiplier >= 0}
              onChange={() => onSignChange(1)}
            />
            <span>+</span>
          </label>
          <label className={`btn ${signMultiplier < 0 ? 'active resources-adjustment-down' : 'btn-outline-secondary '}`}>
            <input
              type="radio"
              disabled={disabled}
              checked={signMultiplier < 0}
              onChange={() => onSignChange(-1)}
            />
            <span>-</span>
          </label>
        </div>
      </div>
    </div>
  )
} 